// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"4a90214c9295418649e0","4406":"beecbac9fa15f99b4682"}[chunkId] + ".css";
};